/**
 * @xivdyetools/types - Error Codes
 *
 * Unified error codes from all xivdyetools projects.
 *
 * @module error/codes
 */
/**
 * Error codes for different failure scenarios
 *
 * Consolidated from xivdyetools-core and xivdyetools-web-app.
 */
export var ErrorCode;
(function (ErrorCode) {
    // Core errors (from xivdyetools-core)
    /** Invalid hex color format provided */
    ErrorCode["INVALID_HEX_COLOR"] = "INVALID_HEX_COLOR";
    /** RGB value out of valid range (0-255) */
    ErrorCode["INVALID_RGB_VALUE"] = "INVALID_RGB_VALUE";
    /** Requested dye ID not found in database */
    ErrorCode["DYE_NOT_FOUND"] = "DYE_NOT_FOUND";
    /** Failed to load dye database */
    ErrorCode["DATABASE_LOAD_FAILED"] = "DATABASE_LOAD_FAILED";
    /** Invalid input provided to function */
    ErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    /** External API call failed */
    ErrorCode["API_CALL_FAILED"] = "API_CALL_FAILED";
    /** Failed to load locale data */
    ErrorCode["LOCALE_LOAD_FAILED"] = "LOCALE_LOAD_FAILED";
    /** Unknown or unexpected error */
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Web-specific errors (from xivdyetools-web-app)
    /** Browser storage quota exceeded */
    ErrorCode["STORAGE_QUOTA_EXCEEDED"] = "STORAGE_QUOTA_EXCEEDED";
    /** Invalid theme name provided */
    ErrorCode["INVALID_THEME"] = "INVALID_THEME";
    /** Failed to load image file */
    ErrorCode["IMAGE_LOAD_FAILED"] = "IMAGE_LOAD_FAILED";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=codes.js.map